import { Layout } from 'antd';
import React, { JSX } from 'react';
// @ts-ignore
import logo from '../assets/logo-dark.png';

const { Header, Footer, Content } = Layout;

const commonLayoutStyle: React.CSSProperties = {
  backgroundColor: '#FFFFFF',
  padding: 0,
  margin: 0
};

const headerStyle: React.CSSProperties = {
  ...commonLayoutStyle,
  paddingBottom: 6,
};

const contentStyle: React.CSSProperties = {
  ...commonLayoutStyle,
};

const footerStyle: React.CSSProperties = {
  ...commonLayoutStyle,
  padding: '36px 0 12px 0',
  fontSize: '11px',
};

const logoStyle: React.CSSProperties = {
  height: 65,
};

const footerTextStyle: React.CSSProperties = {
  textAlign: 'center'
};


export default ({ children }: any) => {
  return (
    <Container>
      <Layout>
        <Header style={headerStyle}>
          <img src={logo} style={logoStyle} alt="Alberta Energy Regulator" />
        </Header>
        <Content style={contentStyle}>
          {children}
        </Content>
        <Footer style={footerStyle}>
          <Container>
            <div style={footerTextStyle}>&copy; {(new Date()).getFullYear()} Alberta Energy Regulator</div>
          </Container>
        </Footer>
      </Layout>
    </Container>
  )
}

// Bootstrap's container implementation
const Container = ({ children }: any): JSX.Element => {
  return (
    <div className="container">{children}</div>
  );
}
